import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { FutureTermPageRoutingModule } from './future-term-routing.module';

import { FutureTermPage } from './future-term.page';
import { TopbannerPageModule } from 'src/app/shared/components/topbanner/topbanner.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    FutureTermPageRoutingModule,
    TopbannerPageModule
  ],
  declarations: [FutureTermPage],
  exports: [FutureTermPage]
})
export class FutureTermPageModule { }
